/**
 * Created by AlexanderC on 6/20/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidSchemaException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when DB model validation schema is missing or broken
 */
let InvalidSchemaException = exports.InvalidSchemaException = function (_Exception) {
  _inherits(InvalidSchemaException, _Exception);

  /**
   * @param {Object} model
   * @param {String} errorString
   */
  function InvalidSchemaException(model, errorString) {
    _classCallCheck(this, InvalidSchemaException);

    return _possibleConstructorReturn(this, (InvalidSchemaException.__proto__ || Object.getPrototypeOf(InvalidSchemaException)).call(this, `deep-db model ${JSON.stringify(model)} validation schema fails: ${errorString}`));
  }

  return InvalidSchemaException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Exception/InvalidSchemaException.js
// module id = 457
// module chunks = 0